import { Component, OnInit, Input, Output, ViewChild, forwardRef, EventEmitter, ElementRef } from '@angular/core';
import * as _ from "lodash";


import * as ent from '../../entities/index'
import * as enums from '../../enums/index'

//filters
import * as filters from '../../filters/index'

//constants

//components
import { DatePipe } from '@angular/common';

@Component({
    selector: 'my-map',
    templateUrl: './Map.component.html'
})
export class MapComponent implements OnInit {


    mapOptions: any;
    overlays: any[] = [];
    defaultZoom: number;
    defaultLat: number;
    defaultLng: number;
    lat: number;
    lng: number;
    map: google.maps.Map;
    defaultUnasignedColor: string;
    circles: any[] = [];


    @Input() height: number;

    @ViewChild('mapDiv') mapDiv: ElementRef;

    getHeightPX(): String {
        let val: String;
        val = `${this.height}px`;
        return val;
    }
    setMap(event: any) {
        this.map = event.map;

    }

    constructor() {

        this.defaultUnasignedColor = "gold";
    }

    ngOnInit() {
        this.defaultZoom = 10;
        this.defaultLat = 42.0157807;
        this.defaultLng = -87.7966234;
        this.lat = this.defaultLat;
        this.lng = this.defaultLng;


        this.setCurrentPosition();
    }
    setCurrentPosition() {

        this.mapOptions = {
            center: { lat: this.lat, lng: this.lng },
            zoom: this.defaultZoom,
            gestureHandling: 'greedy'
        };


        //this.geoLocate();
    }

    geoLocate() {

        if ("geolocation" in navigator) {
            var options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            };

            navigator.geolocation.getCurrentPosition((position) => {

                this.mapOptions = {
                    center: { lat: position.coords.latitude, lng: position.coords.longitude },
                    zoom: 12
                };
                this.map.setOptions(this.mapOptions);
            },
                (err) => {
                    console.log(err);
                },
                options);
        }

    }

    addLocationToMap(address: ent.MyAddress, image: any) {


        if (this.overlays.filter(x => x.position.lat === address.Lat && x.position.lng === address.Lng).length == 0) {
            var foreColor = "Black";
            var marker = new google.maps.Marker({
                position: { lat: address.Lat, lng: address.Lng },
                title: address.FormattedAddress,
                label: {
                    text: "\u25CF",
                    color: foreColor,
                    fontSize: "18px",
                    fontWeight: "bold"
                }
            });
            var pinpath = this.getPinPath();
            image = pinpath;
            if (image) {
                marker.setIcon(image);
            }

            this.overlays.push(marker);
        }

        this.fitMapToMarkers();
    }

    getPinPath(isSelected: boolean = false) {
        var markerColor = this.defaultUnasignedColor;

        markerColor = "blue";

        var strkColor = 'Black';
        var strkWeight = 1;
        var path = 'M0 0 L -3 -14 L -12 -27  A 16 16, 0, 1, 1,12 -27  L 3 -14  Z';
        if (isSelected) {
            strkColor = 'Black';
            strkWeight = 3;
            path = 'M0 0 L -3 -14 L -12 -27  A 16 16, 0, 1, 1,12 -27  L 3 -14  Z';
        }
        var dynamicPath = {
            path: path,
            fillColor: markerColor,
            fillOpacity: 1,
            scale: 1,
            strokeColor: strkColor,
            strokeWeight: strkWeight,
            labelOrigin: new google.maps.Point(0, -37)
        };

        return dynamicPath;


    }

    fitMapToMarkers() {
        if (this.overlays.length > 0) {
            let bounds = new google.maps.LatLngBounds();
            this.overlays.forEach(marker => {
                bounds.extend(marker.getPosition());
            });

            this.map.fitBounds(bounds);
            this.map.panToBounds(bounds);
        }
        this.map.setZoom(16);

    }

    clearMarkers() {
        this.overlays = [];
        for (var circle of this.circles) {
            circle.setMap(null);
        }
    }



}